import styled from "styled-components";
import { flexStyle } from "../styles";

export const FlexCol = styled.div`
  ${flexStyle}
  flex-direction: column;
`;
